module.exports = __webpack_public_path__ + "static/feather-3-4c67bba13a754d19eed92b177528ef45.png";